import { NgModule } from '@angular/core';
import { APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { environment } from '@environments/environment';

@NgModule({
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: (httpLink: HttpLink) => {
        return {
          cache: new InMemoryCache({
            typePolicies: {
              Query: {
                fields: {
                  projects: {
                    merge: (existing = [], incoming: any[]) => {
                      return [...incoming];
                    },
                  },
                },
              },
            },
          }),
          link: httpLink.create({
            uri: `${environment.api.baseUrl}/graphql`,
          }),
        };
      },
      deps: [HttpLink],
    },
  ],
})
export class GraphQlModule { }
